import React from "react";
import styled from "styled-components/macro";
import {
  BaseModalBackground,
  ModalProvider as Provider,
} from "styled-react-modal";
import {
  BaseModalBackground as DesignSystemModalBackground,
  ModalProvider as DesignSystemModalProvider,
} from "@joor/design-system";

const StyledDesignSystemBackground = styled(DesignSystemModalBackground)`
  .autoAttributionModal {
    max-width: 40vw;
  }
`;

const StyledBackground = styled(BaseModalBackground)`
  z-index: 10010;
`;

const ModalProvider: React.FC = ({ children }) => (
  <Provider backgroundComponent={StyledBackground}>
    <DesignSystemModalProvider
      backgroundComponent={StyledDesignSystemBackground}
    >
      {children}
    </DesignSystemModalProvider>
  </Provider>
);

export default ModalProvider;
